import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {useRefraMutation} from '../../useRefraMutation'

import {mutations} from '@refra/api/mutations'
import {logger} from '@refra/modules/common/utils'

export const useUpdateRefractoryCustomization = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.updateRefractoryCustomization,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useUpdateRefractoryCustomization')
        .extras({errorDetails})
        .error('Error occurred while updating refractory customization')

      spawnErrorToast(t('error.updateRefractoryCustomization'))
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        predicate: (query) => {
          if (query.queryKey[0] === 'refractoriesWithCustomization') {
            return true
          }
          return false
        }
      })
      spawnSuccessToast(t('success.updateRefractoryCustomization'))
    }
  })
}
